module.exports = __webpack_public_path__ + "img/tishi-shex.d14ee5ae.png";